module.exports = __webpack_public_path__ + "static/media/pando-logo.7962c322.png";